// extracted by mini-css-extract-plugin
export default {"container":"siteContent_container__g-50F","photo":"siteContent_photo__8cEds","description":"siteContent_description__dN7QX"};